// extracted by mini-css-extract-plugin
module.exports = {"SaveElectricF":"F_SaveElectricF__qqvYz"};